var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropertyNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0078125,
    width: 40.0026,
    height: 40.0026,
    rx: 10.6663,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.909 23.6666C23.2469 23.6666 24.336 24.7478 24.336 26.0769V29.495C24.336 29.7806 24.5649 30.0095 24.8582 30.0162H26.9762C28.6453 30.0162 30.0021 28.676 30.0021 27.0292V17.3348C29.9944 16.768 29.7243 16.2346 29.261 15.8802L21.9346 10.0373C20.9511 9.25831 19.5754 9.25831 18.5886 10.0395L11.3123 15.8779C10.8311 16.2435 10.5611 16.7769 10.5555 17.3537V27.0292C10.5555 28.676 11.9123 30.0162 13.5814 30.0162H15.7194C16.0206 30.0162 16.2651 29.7773 16.2651 29.4839C16.2651 29.4195 16.2728 29.355 16.2862 29.2939V26.0769C16.2862 24.7556 17.3685 23.6755 18.6964 23.6666H21.909ZM26.9762 31.683H24.8382C23.6137 31.6541 22.6691 30.6929 22.6691 29.495V26.0769C22.6691 25.6668 22.328 25.3334 21.909 25.3334H18.702C18.2919 25.3357 17.953 25.6701 17.953 26.0769V29.4839C17.953 29.5672 17.9419 29.6473 17.9186 29.7228C17.7986 30.8229 16.8585 31.683 15.7194 31.683H13.5814C10.9934 31.683 8.88867 29.595 8.88867 27.0292V17.3459C8.89978 16.2413 9.40873 15.2301 10.2877 14.5645L17.5496 8.73603C19.1487 7.46922 21.3767 7.46922 22.9725 8.73381L30.2866 14.5678C31.1456 15.2223 31.6546 16.2313 31.669 17.3225V27.0292C31.669 29.595 29.5643 31.683 26.9762 31.683Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyNav);
export default __webpack_public_path__ + "static/media/property-nav.234637c2c536255ee8dedff398ba50ff.svg";
export { ForwardRef as ReactComponent };